import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import CustomDialog from './Components/CustomDialog';
import { DialogActions, DialogContent, Typography } from '@material-ui/core';
import MainButton from './Components/MainButton';

const useStyles = makeStyles(() => ({
  TypographyCaption: {
    marginTop: 20,
    fontSize: 12,
    lineHeight: 1.7,
  },
  mainButton: {
    backgroundColor: '#83BD02',
    padding: '6px 15px',
    '&:hover': {
      backgroundColor: '#83BD02',
      opacity: 0.5,
    },
  },
}));

export const ConfirmDialog = ({ open, content, onConfirm, onClose, confirmButtonLabel }) => {
  const classes = useStyles();

  return (
    <CustomDialog
      open={open}
      aria-describedby="alert-dialog-description"
      onCancel={onClose}
      onClose={onClose}
    >
      <DialogContent>
        <Typography
          variant="body1"
          id="alert-dialog-description"
          classes={{ root: classes.TypographyCaption }}
        >
          {content}
        </Typography>
      </DialogContent>
      <DialogActions>
        <MainButton onClick={onConfirm} variant="contained" size="medium" className={classes.mainButton}>
          {confirmButtonLabel}
        </MainButton>
      </DialogActions>
    </CustomDialog>
  );
};

ConfirmDialog.propTypes = {
  open: PropTypes.bool,
  content: PropTypes.string,
  onConfirm: PropTypes.func,
  onClose: PropTypes.func,
  confirmButtonLabel: PropTypes.string,
};

export default ConfirmDialog;
